enum QueryKeys {
  Budget = 'budget',
  Categories = 'categories',
  CategoryGroups = 'categoryGroups',
  UserSettings = 'userSettings',
  Plans = 'plans',
  Subscription = 'subscription',
  SubscriptionPlan = 'subscriptionPlan',
  TransactionSplits = 'transactionSplits',
  Transactions = 'transactions',
  TransactionTemplateSplits = 'transactionTemplateSplits',
  TransactionTemplates = 'transactionTemplates',
  UserProfile = 'userProfile',
  Collaborations = 'collaborations',
  Users = 'users',
  Offer = 'offer',
  Target = 'target',
  BankAccount = 'bankAccount',
  NPSSurvey = 'npsSurvey',
  ReferralCode = 'referral-code',
  AssignmentRecords = 'assignment-records',
  Filters = 'filters',
  Loans = 'loans',
  LoansActivities = 'loans-activities',
  LoanSchedule = 'loan-schedule',
  BankInstitutions = 'bank-institutions',
  BankConnections = 'bank-connections',
  BankConnectionOnboardingStatus = 'bank-connection-onboarding-status',
  BankConnectionUsage = 'bank-connection-usage',
  FeatureFlags = 'feature-flags',
  Notifications = 'notifications',
  TransactionSides = 'transaction-sides',
  UserOnboarding = 'user-onboarding',
}

export default QueryKeys
